import {
  addFreeMember,
  checkMemberExist,
  clearGetBuildingDataById,
  getBuildingDataById,
} from "../../../Redux/Members/MembersActions";
import FamilyMemberModal from "../../../Components/User/FamilyMemberModal/FamilyMemberModal";
import { getAllBuildings } from "../../../Redux/Buildings/BuildingActions";
import Packages from "../../../Components/User/Upgrade/Packages/Packages";
import Parking from "../../../Components/User/Upgrade/Parking/Parking";
import Addons from "../../../Components/User/Upgrade/Addons/Addons";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { FaInfoCircle, FaRegTrashAlt } from "react-icons/fa";
import Modal from "../../../Components/Common/Modal/Modal";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import toastHelper from "../../../Util/toastHelper";
import React, { useEffect, useState } from "react";
import { LiaParkingSolid } from "react-icons/lia";
import styles from "./AddFreeMember.module.scss";
import { Link, useNavigate } from "react-router";
import validator from "../../../Util/validator";
import { LuPackage } from "react-icons/lu";

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  bookingAllowed: boolean;
}

interface PackageItem {
  discountRate: number;
  isFamily: boolean;
  isFreeMonth: boolean;
  isMember: boolean;
  isNonMember: boolean;
  noofMember: number;
  packageAmenities: string[];
  packageDescription: string;
  packageId: number;
  packageName: string;
  totalRates: number;
}

const tabs = [
  {
    label: "Info",
    value: "info",
    icon: <FaInfoCircle className={styles.icon} />,
  },
  {
    label: "Packages",
    value: "packages",
    icon: <LuPackage className={styles.icon} />,
  },
  {
    label: "Parking",
    value: "parking",
    icon: <LiaParkingSolid className={styles.icon} />,
  },
  {
    label: "Addons",
    value: "addons",
    icon: <IoIosAddCircleOutline className={styles.icon} />,
  },
];
interface InfoProps {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  idNumber: string;
  setFirstName: React.Dispatch<React.SetStateAction<string>>;
  setLastName: React.Dispatch<React.SetStateAction<string>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  setIdNumber: React.Dispatch<React.SetStateAction<string>>;
  errors: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    idNumber: string;
  };
}
const Info = (props: InfoProps) => {
  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    idNumber,
    setFirstName,
    setLastName,
    setEmail,
    setPhoneNumber,
    setIdNumber,
    errors,
  } = props;
  return (
    <div className={styles.infoContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Personal Information</p>
        <p className={styles.subHeading}>
          Add personal information for the member
        </p>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>First Name</p>
        <input
          className={styles.input}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <p className={styles.error}>{errors.firstName}</p>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Last Name</p>
        <input
          className={styles.input}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <p className={styles.error}>{errors.lastName}</p>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Email</p>
        <input
          className={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <p className={styles.error}>{errors.email}</p>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Phone Number</p>
        <input
          className={styles.input}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <p className={styles.error}>{errors.phoneNumber}</p>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>National ID Number</p>
        <input
          className={styles.input}
          value={idNumber}
          onChange={(e) => setIdNumber(e.target.value)}
        />
        <p className={styles.error}>{errors.idNumber}</p>
      </div>
    </div>
  );
};

function AddFreeMember() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { buildings, buildingsLoading } = useSelector(
    (state: RootState) => state.buildings,
  );
  const {
    buildingDataById,
    buildingDataByIdLoading,
    addFreeMemberLoading,
    checkMemberExistLoading,
  } = useSelector((state: RootState) => state.members);
  const [buildingId, setBuildingId] = useState<string>("");
  const [activeTab, setActiveTab] = useState("info");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [idNumber, setIdNumber] = useState<string>("");
  const [familyMemberModalOpen, setFamilyMemberModalOpen] = useState(false);
  const [familyMembers, setFamilyMembers] = useState<FamilyMember[]>([]);
  const [selectedPackageId, setSelectedPackageId] = useState<number>(-1);
  const [parkingSelections, setParkingSelections] = useState<
    Array<{
      parkingId: string;
      noOfVehicle: number;
      notifyParking: boolean;
    }>
  >([]);
  const [addonSelections, setAddonSelections] = useState<
    Array<{
      addonId: number;
      noofAddonUnits: number;
      notifyAddon: boolean;
    }>
  >([]);

  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    idNumber: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    idNumber: "",
  });

  const selectedPackage: PackageItem | undefined =
    buildingDataById?.packages?.find(
      (pack: PackageItem) => pack?.packageId === selectedPackageId,
    );

  const handleNextTab = () => {
    switch (activeTab) {
      case "info":
        const { errors: infoErrors, isValid } = validator([
          { key: "firstName", value: firstName, type: "text" },
          { key: "lastName", value: lastName, type: "text" },
          { key: "email", value: email, type: "email" },
          { key: "phoneNumber", value: phoneNumber, type: "numberOnly" },
          { key: "idNumber", value: idNumber, type: "text" },
        ]);
        setErrors({ ...errors, ...infoErrors });
        if (isValid) {
          if (!checkMemberExistLoading) {
            const successHandler = () => {
              setActiveTab("packages");
            };

            dispatch(checkMemberExist({ email, successHandler }));
          }
        }

        break;
      case "packages":
        if (selectedPackageId !== -1) {
          if (selectedPackage?.isFamily && !familyMemberModalOpen) {
            setFamilyMemberModalOpen(true);
          } else {
            setActiveTab("parking");
          }
        } else {
          toastHelper.error("Please select a package");
        }
        break;
      case "parking":
        setActiveTab("addons");
        break;
      case "addons":
        if (!addFreeMemberLoading) {
          const params = {
            member: {
              buildingId,
              firstName,
              lastName,
              email,
              phoneNumber,
              idNumber,
            },
            packageId: selectedPackageId,
            parking: parkingSelections,
            addon: addonSelections,
            successHandler: () => {
              navigate("/admin/freemembers", { replace: true });
            },
          };
          dispatch(addFreeMember(params));
        }
        break;
      default:
        break;
    }
  };

  const handleBackwardTab = () => {
    switch (activeTab) {
      case "addons":
        setActiveTab("parking");
        break;
      case "parking":
        setActiveTab("packages");
        break;
      case "packages":
        setActiveTab("info");
        break;
      default:
        break;
    }
  };

  const familyMemberModalHandler = () => {
    if (familyMembers.length === 0) {
      toastHelper.error("Please add at least one member");
      return;
    }
    setFamilyMemberModalOpen(false);
    handleNextTab();
  };

  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
            >
              <React.Fragment>{tab.icon}</React.Fragment>
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContentContainer}>
          <div className={styles.tabContent}>
            {activeTab === "info" && (
              <Info
                firstName={firstName}
                lastName={lastName}
                email={email}
                phoneNumber={phoneNumber}
                idNumber={idNumber}
                setFirstName={setFirstName}
                setLastName={setLastName}
                setEmail={setEmail}
                setPhoneNumber={setPhoneNumber}
                setIdNumber={setIdNumber}
                errors={errors}
              />
            )}
            {activeTab === "packages" && (
              <Packages
                packages={buildingDataById?.packages ?? []}
                selectedPackageId={selectedPackageId}
                setSelectedPackageId={setSelectedPackageId}
              />
            )}

            {activeTab === "parking" && (
              <Parking
                parkings={buildingDataById?.building?.parking || []}
                parkingSelections={parkingSelections}
                setParkingSelections={setParkingSelections}
              />
            )}

            {activeTab === "addons" && (
              <Addons
                addons={buildingDataById?.building?.addon || []}
                addonSelections={addonSelections}
                setAddonSelections={setAddonSelections}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  };

  const searchHandler = () => {
    if (!buildingId) {
      toastHelper.error("Please select a building");
      return;
    }

    if (!buildingDataByIdLoading) {
      dispatch(getBuildingDataById({ buildingId }));
    }
  };

  useEffect(() => {
    dispatch(getAllBuildings());

    return () => {
      dispatch(clearGetBuildingDataById());
    };
  }, []);

  return (
    <React.Fragment>
      {(buildingDataByIdLoading ||
        buildingsLoading ||
        checkMemberExistLoading) && <Loading />}
      <div className={styles.mainContainer}>
        <Link
          to="/admin/freemembers"
          replace
          className={styles.backButtonContainer}
        >
          <button className={styles.button}>
            <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
            Back to Free Members
          </button>
        </Link>
        <div className={styles.headingContainer}>
          <p className={styles.heading}>Add Free Member</p>
        </div>
        <div className={styles.topContainer}>
          <div className={styles.buildingSelectorContainer}>
            <p className={styles.buildingSelectorLabel}>Select Building</p>
            <div className={styles.inputContainer}>
              <select
                className={styles.input}
                value={buildingId}
                onChange={(e) => {
                  setBuildingId(e.target.value);
                  dispatch(clearGetBuildingDataById());
                  setActiveTab("info");
                }}
              >
                {!buildingId && <option value="">Select Building</option>}
                {buildings?.map((building: any, i: number) => (
                  <option key={i} value={building?.buildingId}>
                    {building?.buildingName}
                  </option>
                ))}
              </select>
              <div className={styles.buttonContainer}>
                <button className={styles.button} onClick={searchHandler}>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        {buildingDataById && (
          <div className={styles.bodyContainer}>
            <div className={styles.tabsContainer}>{tabsRenderer()}</div>
            <div className={styles.buttonsContainer}>
              {activeTab !== "info" && (
                <button
                  className={styles.backButton}
                  onClick={handleBackwardTab}
                >
                  Back
                </button>
              )}

              {activeTab === "packages" && selectedPackageId !== -1 && (
                <button
                  className={styles.clearButton}
                  onClick={() => setSelectedPackageId(-1)}
                >
                  <div className={styles.iconContainer}>
                    <FaRegTrashAlt className={styles.icon} />
                  </div>
                  <p className={styles.buttonText}>Reset Selections</p>
                </button>
              )}

              {activeTab === "parking" &&
                parkingSelections.some((s) => s.noOfVehicle > 0) && (
                  <button
                    className={styles.clearButton}
                    onClick={() => setParkingSelections([])}
                  >
                    <div className={styles.iconContainer}>
                      <FaRegTrashAlt className={styles.icon} />
                    </div>
                    <p className={styles.buttonText}>Reset Selections</p>
                  </button>
                )}

              {activeTab === "addons" &&
                addonSelections.some((s) => s.noofAddonUnits > 0) && (
                  <button
                    className={styles.clearButton}
                    onClick={() => setAddonSelections([])}
                  >
                    <div className={styles.iconContainer}>
                      <FaRegTrashAlt className={styles.icon} />
                    </div>
                    <p className={styles.buttonText}>Reset Selections</p>
                  </button>
                )}

              <button
                className={styles.nextButton}
                disabled={
                  activeTab === "addons" &&
                  selectedPackageId === -1 &&
                  !parkingSelections.some((s) => s.noOfVehicle > 0) &&
                  !addonSelections.some((s) => s.noofAddonUnits > 0)
                }
                onClick={handleNextTab}
              >
                {activeTab === "addons" ? "Add" : "Next"}
              </button>
            </div>
          </div>
        )}
      </div>
      <Modal
        isOpen={familyMemberModalOpen}
        setIsOpen={setFamilyMemberModalOpen}
      >
        <FamilyMemberModal
          familyMembers={familyMembers}
          setFamilyMembers={setFamilyMembers}
          packageData={selectedPackageId}
        />
        <div className={styles.proceedButtonContainer}>
          <button onClick={familyMemberModalHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setFamilyMemberModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default AddFreeMember;
